import styled from "styled-components";

const StyledShopMobileButtonEverscore = styled.div`
  width: 100%;
  display: flex;
  border-bottom: 1px solid ${({theme}) => theme.colors.gray2};

  @media (max-width: 859px) {
    position: sticky;
    top: 0;
    background-color: ${({theme}) => theme.colors.white};
    z-index: 1;
  }

  .shop-mobile-button__filter,
  .shop-mobile-button__sort {
    box-sizing: content-box;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    fill: ${({theme}) => theme.colors.brandDark};
    outline: none;
    transition: var(--button-transition);

    &:first-child {
      &:after {
        content: "";
        width: 2px;
        height: 100%;
        position: absolute;
        right: 0;
        align-self: center;
        background-color: ${({theme}) => theme.colors.gray2};
      }
    }

    @media (min-width: 860px) {
      display: none;
    }
  }

  .shop-mobile-button__sort {
    padding-right: 1px;
    height: 44px;
    width: 50%;
  }

  .shop-mobile-button__filter {
    padding: 10px 16px;
    height: 24px;
    width: calc(50% - 32px);
    font-weight: var(--weight-bold);
    color: ${({ theme }) => theme.colors.gray4};

    &:hover,
    &:focus {
      color: ${({theme}) => theme.colors.brand};
      fill: ${({theme}) => theme.colors.brand};
    }
  }

  .shop-mobile-button__filter__counter {
    margin-left: 8px;
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: ${({theme}) => theme.colors.gray4};
    border-radius: 50%;
    color: ${({theme}) => theme.colors.white};
  }
`;
export default StyledShopMobileButtonEverscore;